import * as svg from "../../../assets/listing.svg";

import {iconBuilder} from "./iconBuilder";

export const ListingIcon = iconBuilder(svg, "ListingIcon", "0 0 48 49");
